import {
  CalendarIcon,
  CogIcon,
  ApprovalIcon,
  ReportIcon2,
} from "icons";


const getEventsApprovalSubmenu = (path, isApprover) => {
  return [
    {
      title: isApprover ? "My Approvals" : "My Requests",
      to: path + "/approvals/my-approval",
      path: path + "/approvals/my-approval",
    },
    {
      title: "All Approvals",
      to: path + "/approvals/all-approval",
      path: path + "/approvals/all-approval",
    },
    {
      title: isApprover ? "Approval History" : "Request History",
      to: path + "/approvals/approval-history",
      path: path + "/approvals/approval-history",
    },
  ];
};

const getEventsReportsSubmenu = (path) => {
  return [
    {
      title: "Overview",
      to: path + '/reports-overview',
      path: path + '/reports-overview',
    },
    {
      title: "Properties Breakdown",
      to: path + "/reports-properties",
      path: path + "/reports-properties",
    },
    {
      title: "Events Breakdown",
      to: path + "/reports-events",
      path: path + "/reports-events",
    },
    {
      title: "Invitees Status",
      to: path + "/reports-invitees",
      path: path + "/reports-invitees",
    },
  ];
};

const getEventsSettingsSubmenu = (path) => {
  return [
    {
      title: "Approval Process",
      to: path + "/settings/approval-process",
      path: path + "/settings/approval-process",
    },
    {
      title: "Broker Upload",
      to: path + "/settings/broker-upload",
      path: path + "/settings/broker-upload",
    },
    {
      title: "Universal BCC",
      to: path + "/settings/bcc-list",
      path: path + "/settings/bcc-list",
    },
  ];
};

const getHyEventMenu = (path, isApprover, orgLevel, approvalProccessAccess) => {
  const approvalsSubmenu = getEventsApprovalSubmenu(path, isApprover);
  const reportsSubmenu = getEventsReportsSubmenu(path);
  const settingsSubmenu = getEventsSettingsSubmenu(path);
  return [
    {
      icon_type: (
        <CalendarIcon
          viewBox="0 0 24 24"
          style={{ width: 24, height: 24, fill: "#333", stroke: "#333" }}
        />
      ),
      title: "Events",
      to: path,
      path: path,
    },
    {
      icon_type: (
        <ApprovalIcon
          viewBox="0 0 24 24"
          style={{ width: 24, height: 24, fill: "none", stroke: "#666" }}
        />
      ),
      title: "Approvals",
      children: isApprover ? approvalsSubmenu : [approvalsSubmenu[0], approvalsSubmenu[2]],
    },
    {
      icon_type: (
        <ReportIcon2
          viewBox="0 0 32 32"
          style={{ width: 32, height: 32, fill: "none", stroke: "#333" }}
        />
      ),
      title: "Reports",
      children: orgLevel ? reportsSubmenu : [reportsSubmenu[0], ...reportsSubmenu.slice(2)],
    },
    {
      icon_type: (
        <CogIcon
          viewBox="0 0 24 24"
          style={{ width: 24, height: 24, fill: "none", stroke: "#666" }}
        />
      ),
      title: "Settings",
      children: approvalProccessAccess ? settingsSubmenu : settingsSubmenu.slice(1),
    },
  ];
};

export const getNavDrawerMenu = async (
  path,
  isApprover,
  orgLevel,
  approvalProccessAccess
) => {
  console.log("isApprover", isApprover)
  return getHyEventMenu(path, isApprover, orgLevel, approvalProccessAccess);
};
